import React from 'react';
import FormInput from 'components/Input/FormInput';

export const PosNameInput: React.FC = React.memo(() => {
	return <FormInput testId="PosNameInput" name="posName" label="posNameLabel" maxLength={100} disabled={true} />;
});
